<ion-app>      
    <app-header></app-header>    
    <ion-router-outlet id="app_router"></ion-router-outlet>
</ion-app>
